import { constants } from '../config';

export default function setPrivacyReducer(state = {}, action) {
  switch (action.type) {
    case constants.GET_PRIVACY:
      return { ...state, loading: true, done: false, errorRequest: false };
    case constants.GET_PRIVACY_SUCCESS: {
      return { ...state, loading: false, data: action.payload, done: true };
    }
    case constants.GET_PRIVACY_FAIL:
      return { ...state, loading: false, errorRequest: true };

    default:
      return state;
  }
}
